import React, { useState, useEffect } from 'react'
import { Button, Upload, Col, Row, Popconfirm, Image } from 'antd'
import { Moment } from '../../helpers'
import { DeleteOutlined } from '@ant-design/icons'

export const JobGallery = ({
  jobId,
  beforeImages,
  afterImages,
  onDeleteBeforeImages,
  onDeleteAfterImages,
  canDelete,
}) => {
  useEffect(() => {}, [])

  return (
    <React.Fragment>
      <Row gutter={[4, 4]}>
        <Col span={12}>
          <p>รูปภาพก่อนซ่อม - Before</p>

          <Image.PreviewGroup>
            {beforeImages && beforeImages.length > 0 ? (
              <>
                <span style={{}}>คลิ๊กที่รูป.. เพื่อดูแบบขยาย</span>
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    position: 'relative',
                    width: '100%',
                    backgroundColor: 'rgb(105, 21, 2)',
                    justifyContent: 'space-around',
                  }}
                >
                  {beforeImages.map((bi, bkey) => (
                    <>
                      <div
                        key={bkey}
                        style={{
                          margin: 3,
                          padding: 3,
                          // width: '120px',
                          position: 'relative',
                          backgroundColor: '#ffffff',
                          flexShrink: 3,
                        }}
                      >
                        <Image
                          src={bi.thumbnail}
                          preview={{
                            src: bi.url,
                          }}
                          width={120}
                        />

                        {canDelete ? (
                          <Popconfirm
                            title="ต้องการลบรูปนี้ใช่หรือไม่ ?"
                            okText="ใช่"
                            cancelText="ไม่"
                            onConfirm={() => onDeleteBeforeImages(bi)}
                          >
                            <Button
                              type="danger"
                              size="small"
                              icon={<DeleteOutlined />}
                              style={{
                                position: 'absolute',
                                top: 0,
                                right: 0,
                              }}
                            ></Button>
                          </Popconfirm>
                        ) : null}
                      </div>
                    </>
                  ))}
                </div>
              </>
            ) : null}
          </Image.PreviewGroup>
        </Col>
        <Col span={12}>
          <p>รูปภาพหลังซ่อม - After</p>

          <Image.PreviewGroup>
            {afterImages  && afterImages.length > 0 ? (
              <>
                <span style={{}}>คลิ๊กที่รูป.. เพื่อดูแบบขยาย</span>
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    position: 'relative',
                    width: '100%',
                    backgroundColor: 'rgb(2, 105, 99)',
                    justifyContent: 'space-around',
                    alignItems: 'start',
                  }}
                >
                  {afterImages.map((ai, akey) => (
                    <>
                      <div
                        key={akey}
                        style={{
                          margin: 3,
                          padding: 3,
                          // width: '120px',
                          position: 'relative',
                          backgroundColor: '#ffffff',
                          flexShrink: 3,
                        }}
                      >
                        <Image
                          src={ai.thumbnail}
                          preview={{
                            src: ai.url,
                          }}
                          width={120}
                        />
                        {canDelete ? (
                          <Popconfirm
                            title="ต้องการลบรูปนี้ใช่หรือไม่ ?"
                            okText="ใช่"
                            cancelText="ไม่"
                            onConfirm={() => onDeleteAfterImages(ai)}
                          >
                            <Button
                              type="danger"
                              size="small"
                              icon={<DeleteOutlined />}
                              style={{
                                position: 'absolute',
                                top: 0,
                                right: 0,
                              }}
                            ></Button>
                          </Popconfirm>
                        ) : null}
                      </div>
                    </>
                  ))}
                </div>
              </>
            ) : null}
          </Image.PreviewGroup>
        </Col>
      </Row>
    </React.Fragment>
  )
}
